import BaseEvent from './BaseEvent.js';

class SetImageSourceEvent extends BaseEvent {
  handle(msg) {
    this.context._api.setImageSource(msg.params);
  }
}

class RemoveImageSourceEvent extends BaseEvent {
  handle(msg) {
    this.context._api.removeImageSource(msg.params);
  }
}

export { SetImageSourceEvent, RemoveImageSourceEvent };
